import { useCallback, useContext, useMemo } from 'react';
import { UserSettingsContext } from '../../setup/routes-manager/RequireAuth';
import useAuth from './useAuth';
import { syncUidataNotifyFlags } from '../utility/contactVerifyNotify';

/**
 * Returns a callback that syncs contact-verify + promo popup flags from uidata/status responses.
 */
export default function useSyncUidataNotifyFlags() {
  const { setAuth } = useAuth();
  const { setNotifData, setShowNotif, setInfoPopupData, setShowInfoPopup } =
    useContext(UserSettingsContext);

  const infoPopupHandlers = useMemo(
    () => ({
      setPopupData: setInfoPopupData,
      setShowPopup: setShowInfoPopup,
    }),
    [setInfoPopupData, setShowInfoPopup],
  );

  return useCallback(
    (responseData) => {
      syncUidataNotifyFlags(
        responseData,
        setAuth,
        setNotifData,
        setShowNotif,
        infoPopupHandlers,
      );
    },
    [setAuth, setNotifData, setShowNotif, infoPopupHandlers],
  );
}
